import { inject, Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { User } from '../dto/user.model';
import { authContext } from './auth.interceptor';
import { Dealer } from '../dto/dealer.model';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  httpClient = inject(HttpClient);

  getMyFollowedDealers(): Observable<Dealer[]> {
    return this.httpClient.get<Dealer[]>(environment.apiUrl + '/users/me/followed-dealers', { context: authContext() });
  }

  getMe(): Observable<User> {
    return this.httpClient.get<User>(environment.apiUrl + '/users/me', { context: authContext() });
  }

  putMe(user: Partial<User>): Observable<User> {
    return this.httpClient.put<User>(environment.apiUrl + '/users/me', user, { context: authContext() });
  }
}
